function initialModalModel() {
  return {
    templateType: '',
    data: {},
  };
}

export {initialModalModel};
